import React from 'react';
import CaseStudyLayout from '../../../components/caseStudy/index';
import { CCBenefits, CCTracker, editBenefit } from '../image_index';
import { sections } from './config';

const CreditCardTracker = () => {
    return (
        <CaseStudyLayout
            title='Credit Card Tracker'
            subtitle='Optimizing Personal Finance & Benefit Management'
            heroImage={[CCTracker, CCBenefits, editBenefit]}
            duration='June 2026 - Present'
            tools='Figma, SCSS'
            role='Product Designer & Frontend Developer'
            summary={(
                <p>
                    A personal finance web application designed to help multi-card holders manage annual fees, track credit card benefits, and maximize perk utilization through a clean, centralized dashboard.
                </p>
            )}
            sections={sections}
        />
    );
}

export default CreditCardTracker;